// extracted by mini-css-extract-plugin
module.exports = {"container":"delayPeriod_container__LbKZR","end":"delayPeriod_end__qffrG","update":"delayPeriod_update__5vlhr","text":"delayPeriod_text___34nW","time":"delayPeriod_time__1ROnb"};